module.exports = __webpack_public_path__ + "static/scale-model-of-water-taxi-in-fort-lauderdale-florida-3ffd1803b5900a5eb2a9e6b71e40a96a.png";